// modules
import { mapState } from 'vuex'
import { RTable } from '@/components/reusable_components/next'
import AccAccountingSeatConceptService from '@/services/api/accounting/AccAccountingSeatConcept'
import TranslatorService from '@/services/translator'

// partials
import AccAccountingSeatConceptFilters from "@/views/Accounting/AccAccountingSeatConcept/filters"
import AccAccountingSeatConceptHeaders from "@/views/Accounting/AccAccountingSeatConcept/headers"

// components
export default {
  components: {
    RTable
  },
  computed: {

    /**
     * 
     */
    ...mapState('SnackbarModalModule', {
      responseConfirmSnackbar: 'responseConfirm',
    }),

    /**
     * 
     */
    tableProps() {
      return {
        filters: AccAccountingSeatConceptFilters.toList(),
        headers: AccAccountingSeatConceptHeaders.toList(),
        service: AccAccountingSeatConceptService.toList(),
      }
    }
  },
  data() {
    return {
      selected: null,
    }
  },
  methods: {

    /**
     * 
     */
    goCreate() {
      this.$router.push({ name: 'acc-accounting-seat-concept-create' })
    },

    /**
     * 
     */
    onDetail(event) {
      this.$router.push({ name: 'acc-accounting-seat-concept-update', params: { id: event.item.id } })
    },

    /**
     * 
     */
    onError(error) {
      this.showErrorSnackbar(TranslatorService(AccAccountingSeatConceptService.model(), error.response.data))
    },

    /**
     * 
     */
    onRemove(event) {

      //
      this.selected = event.item

      //
      this.showWarningSnackbar({ 
        title: 'Eliminar concepto',
        message: 'Una vez eliminado no se puede recuperar.',
        confirm: 'eliminar',
      })
    },

    /**
     * 
     */
    onSuccess() {
      this.showSuccessSnackbar('Concepto eliminado exitosamente.')
    },

    /**
     * 
     */
    refresh() {
      this.$refs.table.refresh()
    },

    /**
     * 
     */
    remove() {
      AccAccountingSeatConceptService.remove(this.selected).then(this.onSuccess).then(this.refresh).catch(this.onError)
    }
  },
  mounted() {
    this.setTitle('Conceptos')
    this.setItems([
      {
        text: 'crear concepto',
        icon: 'add_circle',
        action: this.goCreate,
      },
    ])
  },
  watch: {
    responseConfirmSnackbar(value) {
      switch(value) {
        case 'eliminar': return this.remove()
      }
    }
  }
}